export function toBooleanFlag(value) {
  return value === true || value === 1 || value === "1";
}

export function isTemplateRule(rule) {
  return toBooleanFlag(rule && rule.isTemplate);
}

export function isEditableFlag(value) {
  return toBooleanFlag(value);
}

export function canEditRule(rule, isSuperUser = false) {
  if (!rule) {
    return false;
  }
  return (!isTemplateRule(rule) || isSuperUser) && rule.canEdit !== false && rule.canEdit !== 0 && rule.canEdit !== "0";
}

export function canDeleteRule(rule, isSuperUser = false) {
  if (!rule) {
    return false;
  }
  return (!isTemplateRule(rule) || isSuperUser) && toBooleanFlag(rule.canDelete);
}

export function normalizeRuleListPayload(payload) {
  const data = payload && Object.prototype.hasOwnProperty.call(payload, "data")
    ? payload.data
    : payload;
  if (Array.isArray(data)) {
    return data;
  }
  if (data && Array.isArray(data.records)) {
    return data.records;
  }
  return [];
}

export function getLaunchableRules(payload) {
  return normalizeRuleListPayload(payload).filter((rule) => !isTemplateRule(rule));
}
